// extracted by mini-css-extract-plugin
module.exports = {"container":"ShopProductList__container","bestSellers":"ShopProductList__bestSellers","newProducts":"ShopProductList__newProducts"};